/**
 * 2-frame walking animation pixel matrices for puppets.
 * Each frame is a 2x2 grid of palette color indices (8px blocks -> 16x16 pixels).
 *
 * Palette reference:
 *   0=black  1=white  2=red      3=green    4=blue     5=yellow
 *   6=cyan   7=magenta 8=brown    9=orange  10=lt green 11=lt blue
 *  12=pink  13=lt yell 14=dk gray 15=lt gray
 */

import { PuppetKind } from './client_message_protocol';

export const PUPPET_SPRITES: Record<PuppetKind, number[][][]> = {
  [PuppetKind.Transporter]: [
    // Frame 1: legs spread (stepping)
    [
      [6, 11],
      [1, 1],
    ],
    // Frame 2: legs together
    [
      [6, 11],
      [0, 0],
    ],
  ],

  [PuppetKind.Combat]: [
    // Frame 1: legs spread (stepping)
    [
      [2, 9],
      [1, 1],
    ],
    // Frame 2: legs together
    [
      [2, 9],
      [0, 0],
    ],
  ],
};
